import{useRef as r,useEffect as t}from"react";export default e=>{var a=r(e);return t(()=>{a.current=e}),a};
//# sourceMappingURL=index.mjs.map
